<style scoped="scoped" lang="scss">
/* .baoyangxianginput {
  width: 30px;
  } */
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}

._printContent /deep/ .el-form-item__label {
  text-align: right;
  vertical-align: middle;
  font-size: 57px;
  color: black;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  font-family: '微软雅黑';
}

._printContent /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: black;
  display: inline-block;
  font-size: 57px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 300px;
  line-height: 57px;
  height: 57px;
  font-family: '微软雅黑';
}

._printContent /deep/ form .el-input {
  width: 300px;
}

.printFontFamily {
  font-family: '微软雅黑';
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/plan/page" @afterGet="afterGet" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.noInMainAndChild"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao(jingzhun)')">
            <el-input v-model="yt.conditions.noEqual"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma')">
            <el-input v-model="yt.conditions.materialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('kehu')">
            <el-select size="mini" v-model="yt.conditions.wmsCustomerId" filterable :placeholder="$t('qingxuanze')">
              <el-option v-for="item in customerList" :key="item.id" :label="item.code + ' ' + item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('daipaichan')" :value="1"></el-option>
              <el-option :label="$t('yipaichan')" :value="2"></el-option>
              <el-option :label="$t('guanbi')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shifouwangong')">
            <el-select v-model="yt.conditions.completed">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planStartTimeStart" :end.sync="yt.conditions.planStartTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.planEndTimeStart" :end.sync="yt.conditions.planEndTimeEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('huohao')">
            <el-input v-model="yt.conditions.articleNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchandingdanfenluid')">
            <el-input v-model="yt.conditions.orderEntryId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
            <el-input v-model="yt.conditions.erpRequireSourceNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('erpkehubianma')">
            <el-input v-model="yt.conditions.customerCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('erpwuliaobianma')">
            <el-input v-model="yt.conditions.erpMaterialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chuhuoriqi')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.deliveryDateStart" :end.sync="yt.conditions.deliveryDateEnd"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('paixuguize')">
            <el-select v-model="yt.conditions.deliveryDateOrderBy" clearable>
              <el-option :label="$t('chuhuoriqishegnxu')" :value="1"></el-option>
              <el-option :label="$t('chuhuoriqijiangxu')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          v-if="utils.checkPower('web_order_management_production_plan_add')"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog);
            setDefaultValue1();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_batchReorder')" size="mini" @click="yt.showEditDialog('piliangchongpai', null, '1500px')" type="primary">
          {{ $t('piliangchongpai') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_merge')" size="mini" @click="yt.showEditDialog('hedan', null, '80%')" type="primary" plain>
          {{ $t('hedan') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_batch_import')" style="margin-left: 10px;" size="mini" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_batchImportScheduling_ql')" style="margin-left: 10px;" size="mini" @click="batchImportSchedulingShow = !batchImportSchedulingShow" plain>
          {{ $t('piliangdaorupaichan') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_batchUpdateActualCavity')" style="margin-left: 10px;" size="mini" @click="batchUpdateActualCavity()" plain>
          {{ $t('gengxinshijimoqiangshu') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_batchImportSchedulingDistribution')" style="margin-left: 10px;" size="mini" @click="batchImportSchedulingDistributionShow = !batchImportSchedulingDistributionShow">
          {{ $t('piliangdaorupaichanfafang') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_checkMaterialRequirement_zhengdaxing')" style="margin-left: 10px;" size="mini" @click="materialRequirementShow = true" type="primary">
          {{ $t('chaxunwuliaoxuqiu') }}
        </el-button>
        <!-- 获取ERP即时库存按钮 -->
        <el-button :loading="yt.editObj.loading" v-if="utils.checkPower('web_order_management_production_plan_getMaterialInventory_wode')" style="margin-left: 10px;" size="mini" @click="getMaterialInventoryWode()" type="primary">
          {{ $t('erpjishikucun') }}
        </el-button>
        <!-- 新增同步生产计划按钮 -->
        <el-button size="mini" :loading="yt.editObj.loading" v-if="utils.checkPower('web_custom_plan_send_sync_plan_lth')" @click="syncPlanLth" plain>
          {{ $t('web_custom_plan_send_sync_plan_lth') }}
        </el-button>
        <el-button v-if="utils.checkPower('web_order_management_production_plan_batchClose')" style="margin-left: 10px;" size="mini" @click="yt.showEditDialog('piliangguanbi', null, '70%')" type="primary">
          {{ $t('piliangguanbi') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button :loading="plan_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #zhuangtai="scope">
        <el-tag :type="scope.row.status === 2 ? 'success' : scope.row.status === 3 ? 'danger' : 'warning'" size="mini">
          {{ $t(store.state.dictJsonAll['PRODUCTION_PLAN_STATUS'][scope.row.status]) }}
        </el-tag> </template
      ><el-form-item :label="$t('zhuangtai')">
        <el-select v-model="yt.conditions.status">
          <el-option :label="$t('daipaichan')" :value="1"></el-option>
          <el-option :label="$t('yipaichan')" :value="2"></el-option>
          <el-option :label="$t('guanbi')" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <template #shifouwangong="scope">
        <el-tag :type="scope.row.completed ? 'success' : 'warning'" size="mini">
          {{ scope.row.completed ? $t('shi') : $t('fou') }}
        </el-tag>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col v-if="scope.row.children || scope.row.parentId == null" :span="0.1">
            <el-button v-if="utils.checkPower('web_order_management_production_plan_schedule_giveout') && scope.row.status == 1" type="text" @click="toScheduling(scope.row)">{{ $t('paichan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_order_management_production_plan_bom_create')" type="text" @click="yt.showEditDialog('plan_bom', scope.row, 'w2')">
              {{ $t('jihuadanbom') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_order_management_production_plan_woForPlan') && scope.row.schedulingQuantity > 0" type="text" @click="yt.showEditDialog('shengchangongdan', scope.row, '900px')">
              {{ $t('shengchangongdan') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_order_management_production_plan_edit') && (scope.row.children || scope.row.parentId == null)">
            <el-button
              v-if="scope.row.status == 1"
              type="text"
              @click="
                splitOrg(scope.row);
                yt.showEditDialog('bianji', scope.row, 'w2', beforeEdit);
              "
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="scope.row.type == 1" @click="yt.showEditDialog('hedanjilu', scope.row, '900px')">
              {{ $t('hedanjilu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button :loading="store.state.global_loading" v-if="utils.checkPower('web_order_management_production_plan_delete') && scope.row.schedulingQuantity == 0" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/production/plan/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <el-button v-if="scope.row.status != 3 && scope.row.schedulingQuantity == 0 && scope.row.parentId == null && utils.checkPower('web_order_management_production_plan_addChildrenPlan')" type="text" @click="yt.showEditDialog('zengjiafudan', scope.row, '1400px', beforeShowEditDialog)">
            {{ $t('zengjiafudan') }}
          </el-button>
          <el-button v-if="utils.checkPower('web_order_management_production_plan_printLabel') && scope.row.status != 3" type="text" @click="printLabel(scope.row)">
            {{ $t('dayinbiaoqian') }}
          </el-button>

          <el-col :span="0.1">
            <el-button :loading="store.state.global_loading" v-if="utils.checkPower('web_order_management_production_plan_unbind') && scope.row.schedulingQuantity == 0 && scope.row.parentId != null" type="text" @click="unbind(scope.row)">{{ $t('jiechubangding') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button
              v-if="utils.checkPower('web_order_management_production_plan_close') && scope.row.status === 1"
              type="text"
              @click="
                yt.editObj = scope.row;
                yt.req('POST', '/web/production/plan/close', beforeReq);
              "
              >{{ $t('guanbi') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.editObj.action == 'paichan' ? '600px' : yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'plan_bom'">
        <div class="dialog-scroller">
          <bom :bomWork="yt.editObj"></bom>
        </div>
      </template>
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{ $t('zhuchanpin') }}</p>
            <el-form-item :label="$t('jihuadanhao')" required>
              <el-input v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('duogongxuchejian')" v-if="utils.checkPower('web_order_management_production_plan_multi_process_org')">
              <yi_data_select :multiple="true" :type="'organization'" :ids.sync="yt.editObj.multiProcessOrg"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('kucunzuzhi')" v-if="utils.checkPower('web_order_management_production_plan_multi_process_org')">
              <el-input v-model="yt.editObj.attribute1"></el-input>
            </el-form-item>
            <el-form-item :label="$t('gongdanzhongxin')" v-if="utils.checkPower('web_order_management_production_plan_multi_process_org')">
              <el-input v-model="yt.editObj.attribute2"></el-input>
            </el-form-item>
            <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
              <yi_cross_select style="width: 545px" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId" @getItems="getItem"></yi_cross_select>
            </el-form-item>

            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              <!-- <el-button type="text" @click="showRemark = !showRemark">{{ $t('qingkongbeizhu') }}</el-button> -->
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
              <el-input v-model="yt.editObj.erpRequireSourceNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehu')">
              <el-select size="mini" v-model="yt.editObj.wmsCustomerId" filterable :placeholder="$t('qingxuanze')" clearable>
                <el-option v-for="item in customerList" :key="item.id" :label="item.code + ' ' + item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('chuhuoriqi')">
              <yi_time_input type="datetime" :time.sync="yt.editObj.deliveryDate" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('sehao')" required v-show="colorNoEnable">
              <yi_dictionary_select :multiple="false" type="CUSTOMER_MATERIAL_COLOR_NO" :ids.sync="yt.editObj.colorNo"></yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('yujilingliaoliang')">
              <el-input-number size="small" v-model="yt.editObj.prePicking" :precision="3" :step="1" :min="0" disabled></el-input-number>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('yimuduopin') }}
            </p>
            <div v-if="yt.editObj.children.length > 0" style="display: flex;flex-wrap: nowrap;">
              <el-form-item :label="$t('jihuadanhao')" label-width="130px" required></el-form-item>
              <el-form-item :label="$t('chanpinbianma/mingcheng')" label-width="155px" required></el-form-item>
              <el-form-item :label="$t('jihuashuliang')" label-width="90px" required></el-form-item>
              <el-form-item :label="$t('ERPgongdanhao')" label-width="122px"></el-form-item>
              <el-form-item :label="$t('beizhu')" label-width="82px"></el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <template>
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input v-model="item.no" type="text" size="mini"></el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"></yi_cross_select>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="item.quantity" size="mini"></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini"></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini"></el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br />
            <el-form-item size="mini" style="margin-top: -20px;">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaofuchanpin') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button
            :loading="yt.editObj.loading"
            size="mini"
            @click="
              assembleOrg(yt.editObj);
              yt.req('POST', '/web/production/plan/create');
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 增加副单 -->
      <template v-if="yt.editObj.action == 'zengjiafudan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{ $t('zhuchanpin') }}</p>
            <el-form-item :label="$t('jihuadanhao')" class="noborder">
              <el-input disabled v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhuchanpin')" class="noborder">
              <yi_cross_select disabled style="width: 275px" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" class="noborder">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('yimuduopin') }}
            </p>
            <p style="font-size: 15px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('shougongxinzeng') }}
            </p>
            <div v-if="yt.editObj.children && yt.editObj.children.length > 0">
              <el-form-item style="margin-left: 1px;" :label="$t('jihuadanhao')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 114px;" :label="$t('chanpinbianma/mingcheng')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 79px;" :label="$t('jihuashuliang')" label-width="105px" required></el-form-item>
              <el-form-item style="margin-left: 119px;" :label="$t('ERPgongdanhao')" label-width="105px"></el-form-item>
              <el-form-item style="margin-left: 79px;" :label="$t('beizhu')" label-width="105px"></el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <template>
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input v-model="item.no" type="text" size="mini"></el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select style="width:20px" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"></yi_cross_select>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="item.quantity" size="mini"></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini"></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini"></el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br />
            <el-form-item size="mini" style="margin-top: -20px;">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaofuchanpin') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
          <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
            {{ $t('yiyoujihua') }}
          </p>
          <!-- table表格 -->
          <existing_plans ref="existingPlans" :parentPlan="yt.editObj"></existing_plans>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/plan/addChildrenPlan', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 38px">{{ $t('zhuchanpin') }}</p>
            <el-form-item class="noborder" :label="$t('jihuadanhao')" required>
              <el-input disabled v-model="yt.editObj.no"></el-input>
            </el-form-item>
            <el-form-item :label="$t('guishuchejian')" required>
              <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('duogongxuchejian')" v-if="utils.checkPower('web_order_management_production_plan_multi_process_org')">
              <yi_data_select :multiple="true" :type="'organization'" :ids.sync="yt.editObj.multiProcessOrg"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('kucunzuzhi')">
              <el-input v-model="yt.editObj.attribute1"></el-input>
            </el-form-item>
            <el-form-item :label="$t('gongdanzhongxin')">
              <el-input v-model="yt.editObj.attribute2"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
              <yi_cross_select style="width: 545px" :disabled="schedulingQuantityDisabled" :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId" @getItems="getItem"></yi_cross_select>
            </el-form-item>
            <el-form-item :label="$t('jihuakaishi/wanchengshijian')" required>
              <yi_time_input type="datetimerange" :start.sync="yt.editObj.startTime" :end.sync="yt.editObj.endTime" :placeholder="$t('xuanzeriqiheshijian')"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuashuliang')" required>
              <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <el-form-item :label="$t('ERPgongdanhao')">
              <el-input v-model="yt.editObj.erpNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('erpxuqiulaiyuandanhao')">
              <el-input v-model="yt.editObj.erpRequireSourceNo"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehu')">
              <el-select size="mini" v-model="yt.editObj.wmsCustomerId" filterable :placeholder="$t('qingxuanze')" clearable>
                <el-option v-for="item in customerList" :key="item.id" :label="item.code + ' ' + item.name" :value="item.id"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('chuhuoriqi')">
              <yi_time_input type="datetime" :time.sync="yt.editObj.deliveryDate" format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
            </el-form-item>
            <!-- 预留量 -->
            <el-form-item :label="$t('yujilingliaoliang')">
              <el-input-number size="small" v-model="yt.editObj.prePicking" :precision="3" :step="1" :min="0" disabled></el-input-number>
            </el-form-item>
            <p style="font-size: 18px;margin-left: 70px;margin-bottom: 26px;margin-top: 38px">
              {{ $t('yimuduopin') }}
            </p>
            <!-- scope.row.children || (scope.row.parentId == null) -->
            <div v-if="yt.editObj.children.length > 0" style="display: flex;flex-wrap: nowrap;">
              <el-form-item :label="$t('jihuadanhao')" label-width="130px" required></el-form-item>
              <el-form-item :label="$t('chanpinbianma/mingcheng')" label-width="155px" required></el-form-item>
              <el-form-item :label="$t('jihuashuliang')" label-width="90px" required></el-form-item>
              <el-form-item :label="$t('ERPgongdanhao')" label-width="122px"></el-form-item>
              <el-form-item :label="$t('beizhu')" label-width="82px"></el-form-item>
            </div>
          </el-form>
          <el-form class="_form">
            <div>
              <el-form-item v-for="(item, index) in yt.editObj.children" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <template v-if="yt.editObj.children.length > 0 || parentIds">
                  <el-col :span="0.2">&nbsp;</el-col>
                  <el-col :span="2">
                    <el-input disabled v-model="item.no" type="text" size="mini"></el-input>
                  </el-col>
                  <el-col :span="2">&nbsp;</el-col>
                  <el-col :span="3">
                    <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="item.materialId"></yi_cross_select>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="item.quantity" size="mini"></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.erpNo" type="text" size="mini"></el-input>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="3">
                    <el-input v-model="item.remark" type="text" size="mini"></el-input>
                  </el-col>
                </template>
              </el-form-item>
            </div>
            <br />
            <el-form-item size="mini" style="margin-top: -20px;" v-if="yt.editObj.children == null && yt.editObj.parentId == null">
              <el-col :span="2">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaofuchanpin') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button
            :loading="yt.editObj.loading"
            size="mini"
            @click="
              assembleOrg(yt.editObj);
              yt.req('POST', '/web/production/plan/update');
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 排产 -->
      <template v-if="yt.editObj.action == 'paichan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <div style="width: 70%;display: flex;flex-wrap: nowrap;justify-content: space-between;align-items: center;font-family: Microsoft YaHei UI;margin-bottom: 16px;font-size: 16px;">
              <div>
                <span>{{ $t('zhuchanpin') }}:</span>
                <span style="margin-left: 10px;">{{ yt.editObj.material && yt.editObj.material.name }}</span>
              </div>
              <div v-show="colorNoEnable">
                <span>{{ $t('sehao') }}:</span>
                <span style="margin-left: 10px;">{{ $t($store.state.dictJson['CUSTOMER_MATERIAL_COLOR_NO'][yt.editObj.colorNo]) }}</span>
              </div>
            </div>
            <el-form-item :label="$t('mujubianhao/mingcheng')" required>
              <yi_cross_select :max="1" :selectTitle="'no,name'" @getItems="getItems" :component="'web_order_management_production_plan_mold_list'" :ids.sync="yt.editObj.mouldId" :materialId="yt.editObj.materialId"></yi_cross_select>
            </el-form-item>
            <div style="display: flex;">
              <el-form-item :label="$t('shebeimingcheng')" required>
                <yi_cross_select v-if="isShowAdaptEqSelect" :disabled="disabled1" :max="1" :component="'web_order_management_production_plan_equipment_list'" :ids.sync="yt.editObj.equipmentId" :mouldId="yt.editObj.mouldId" :materialId="yt.editObj.materialId"></yi_cross_select>
              </el-form-item>
              <div v-if="recommendEquipment" style="width: 190px;">
                {{ $t('tuijian') }}:{{ recommendEquipment.name }}
                <el-button type="text" @click="choose">{{ $t('xuanze') }}</el-button>
              </div>
            </div>
            <el-form-item class="noborder" :label="$t('kepaichanshuliang')">
              <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="scheduling"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencijihuashuliang')" required>
              <el-input-number v-model="yt.editObj.curQuantity" :precision="0" :disabled="yt.editObj.mouldId === undefined || yt.editObj.mouldId === ''" :max="maxValue" @input="changePlanNumber" />
            </el-form-item>
            <el-form-item :label="$t('jihuakaishishijian')" required>
              <yi_time_input :disabled="yt.editObj.mouldId === undefined || yt.editObj.mouldId === ''" :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.startTime" @update:time="changeStartTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jihuawanchengshijian')" required>
              <yi_time_input :disabled="yt.editObj.mouldId === undefined || yt.editObj.mouldId === ''" type="datetime" :time.sync="yt.editObj.endTime" @update:time="changeEndTime"></yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('gongdanshunxu')" required>
              <el-input type="number" @input="onInput()" oninput="value=value.replace(/^0+(\d)|[^\d]+/g,'')" v-model="yt.editObj.priority"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
              <el-input-number v-model="yt.editObj.actualCavity" controls-position="right" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('gongyiluxianbianma/mingcheng')" required>
              <yi_data_select type="craft" :ids.sync="yt.editObj.craftId"></yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
            </el-form-item>
            <el-form-item :label="firstEmployeeLabel" v-if="employeeNoShow">
              <el-input v-model="yt.editObj.firstEmployee"></el-input>
            </el-form-item>
            <el-form-item :label="secondEmployeeLabel" v-if="employeeNoShow">
              <el-input v-model="yt.editObj.secondEmployee"></el-input>
            </el-form-item>
            <el-form-item :label="$t('hegelv')" v-if="materialPassRateShow && yt.editObj.material">
              <el-input v-model="yt.editObj.material.passRate" :disabled="true"></el-input>
            </el-form-item>
            <!-- 子计划单 -->
            <div v-for="(item, index) in yt.editObj.children" :key="index">
              <div style="display: flex;flex-wrap: nowrap;align-items: center;font-family:Microsoft YaHei UI;margin-bottom: 16px;font-size: 16px;">
                <span>{{ $t('yimuduopin') }}:</span>
                <span v-if="item.material" style="margin-left: 10px;">{{ item.material.name }}</span>
              </div>
              <el-form-item class="noborder" :label="$t('kepaichanshuliang')">
                <el-input disabled type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" :value="item.quantity - item.schedulingQuantity"></el-input>
              </el-form-item>
              <el-form-item :label="$t('bencijihuashuliang')" required>
                <el-input-number v-model="item.curQuantity" :precision="0" :max="maxValue2" />
              </el-form-item>
              <el-form-item :label="$t('shijimoqiangshu')" required="required" label-width="145px">
                <el-input-number v-model="item.actualCavity" controls-position="right" :min="1"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('hegelv')" v-if="materialPassRateShow && item.material">
                <el-input v-model="item.material.passRate" :disabled="true"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="getScheduling(yt.editObj)" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="getSchedulingAndGiveOut(yt.editObj)" type="primary">
            {{ $t('baocunbingpaichanfafang') }}
          </el-button>
          <el-button size="mini" v-if="utils.checkPower('web_order_management_production_plan_customized_calculateWeight')" :loading="yt.editObj.loading" @click="getQunlongWorkOrders(yt.editObj)" type="primary">
            {{ $t('paichanbingjisuanzhongliang') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action === 'piliangchongpai'">
        <div class="dialog-scroller">
          <yi_excel_import ref="weiErPlanOrderBatchReorder" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'wei_er_plan_order_batch_reorder'" :uploadApi="'/custom/weier/plan/batchReorder'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="mainSubImportLoading" @click="mainSubImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>

      <!-- 合单记录 -->
      <template v-if="yt.editObj.action == 'hedanjilu'">
        <div class="dialog-scroller">
          <combination_record ref="combination" :record="yt.editObj"></combination_record>
        </div>
      </template>
      <!-- 合单 -->
      <template v-if="yt.editObj.action == 'hedan'">
        <div class="dialog-scroller">
          <combine :colorNoEnable="colorNoEnable" ref="combineOrders"></combine>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="submitCombine" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'shengchangongdan'">
        <div class="dialog-scroller">
          <work_order :work="yt.editObj"></work_order>
        </div>
      </template>
      <!-- 批量关闭 -->
      <template v-if="yt.editObj.action === 'piliangguanbi'">
        <div class="dialog-scroller">
          <batchClose ref="batchCloseRef"></batchClose>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="batchClosePlan()" type="primary">
            {{ $t('piliangguanbi') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 导入excel -->
    <importExcel v-if="inited" :show.sync="show" :colorNoEnable="colorNoEnable" />
    <!-- 批量导入排产 -->
    <batchImportScheduling :show.sync="batchImportSchedulingShow" />
    <!-- 批量导入排产发放 -->
    <batchImportSchedulingDistribution :show.sync="batchImportSchedulingDistributionShow" />
    <!-- 查询物料需求(正大兴) -->
    <el-dialog :visible.sync="materialRequirementShow" append-to-body="append-to-body" width="1000px" :before-close="closematerialRequirement">
      <div class="dialog-scroller">
        <material_requirement v-if="materialRequirementShow" />
      </div>
    </el-dialog>
    <!-- 打印标签 -->
    <el-dialog :show-close="true" :visible.sync="isShowPrintDialog" width="1100px" append-to-body="append-to-body" :before-close="closePrintDialog">
      <div class="dialog-scroller" v-if="isShowPrintDialog" style="height: 500px;width: 1000px;">
        <div id="printContent" style="margin-top: 15px" class="_printContent">
          <el-form :inline="true" size="mini" label-width="0px">
            <div style="display:flex;justify-content: center;">
              <div v-if="isShowQrCode" style="position: absolute;right: 30px;">
                <vue-qr :text="printObj.no + '/' + printObj.material.code" :margin="0" :size="95"></vue-qr>
              </div>
            </div>
            <div style="margin-top: 15px;" class="printFontFamily">
              <div style="display: flex;">
                <div style="font-size: 57px;color: black">编号</div>
                <div style="font-size: 57px;margin-left: 20px;color: black">{{ printObj.material.code }}</div>
              </div>
              <div style="display: flex;">
                <div style="font-size: 57px;color: black">名称</div>
                <div style="width:850px;font-size: 57px;margin-left: 20px;color: black">{{ printObj.material.name }}</div>
              </div>
              <div style="display: flex;">
                <div style="font-size: 57px;color: black">{{ $t('guige') }}</div>
                <div style="width:850px;font-size: 57px;margin-left: 20px;color: black">{{ printObj.material.spec }}</div>
              </div>
              <div style="display: flex;">
                <div style="font-size: 57px;color: black">{{ $t('shuliang') }}</div>
                <el-input v-if="!isPrint" style="margin-left: 20px;" type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="printObj.quantity"></el-input>
                <span v-if="!isPrint" style="font-size: 57px;margin-left: 10px;color: black">pcs</span>
                <div v-if="isPrint" style="width:850px;font-size: 57px;margin-left: 20px;color: black">{{ printObj.quantity }} pcs</div>
              </div>
              <div style="display: flex;">
                <div style="font-size: 57px;color: black">{{ $t('caizhi') }}</div>
                <div style="width:850px;font-size: 57px;margin-left: 20px;color: black">{{ printObj.material.color }}&nbsp;{{ printObj.material.ingredient }}</div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer" style="display: block;text-align: center;">
        <div style="margin-top:10px;margin-bottom: 20px;">
          <el-checkbox v-model="isShowQrCode">{{ $t('shifouxianshierweima') }}</el-checkbox>
        </div>
        <div>
          <el-button @click="dayin()" type="primary" style="width: 130px">{{ $t('dayin') }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import combine from '@@/pages/web/order_management/production_plan/combine';
import importExcel from '@@/pages/web/order_management/production_plan/import_excel';
import work_order from '@@/pages/web/order_management/production_plan/work_order/list';
import combination_record from '@@/pages/web/order_management/production_plan/combination_record';
import existing_plans from '@@/pages/web/order_management/production_plan/existing_plans';
import batchImportScheduling from '@@/pages/web/order_management/production_plan/batch_import_scheduling';
import batchImportSchedulingDistribution from '@@/pages/web/order_management/production_plan/batch_import_scheduling_distribution';
import material_requirement from '@@/pages/web/order_management/production_plan/material_requirement';
import bom from '@@/pages/web/order_management/production_plan/bom';
import html2canvas from 'html2canvas';
import VueQr from 'vue-qr';
import print from 'print-js';
import batchClose from '@@/pages/web/order_management/production_plan/batch_close';
import Bury from '@/common/bury.js';

export default {
  name: 'web_order_management_production_plan_list',
  components: {
    importExcel,
    combine,
    work_order,
    combination_record,
    existing_plans,
    batchImportScheduling,
    batchImportSchedulingDistribution,
    material_requirement,
    VueQr,
    bom,
    batchClose
  },
  data() {
    return {
      grossWeight: 0,
      mainSubImportLoading: false,
      plan_export_loading: false,
      childrenParentId: null,
      actualCavity: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      schedulingQuantityDisabled: true,
      mouldStatus: '',
      objectList: '',
      schedulingList: '',
      parentIds: '',
      scheduling: '',
      cavity: '',
      cycle: '',
      showTitle: false,
      showTitle1: false,
      disabled1: true,
      show: false,
      batchImportSchedulingShow: false,
      batchImportSchedulingDistributionShow: false,
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      isShowAdaptEqSelect: true,
      isShowPrintDialog: false,
      printObj: {},
      isPrint: false,
      isShowQrCode: false,
      recommendEquipment: null,
      materialRequirementShow: false,
      employeeNoShow: false,
      materialPassRateShow: false,
      firstEmployeeLabel: '',
      secondEmployeeLabel: '',
      customerList: [],
      orderBy: {
        orderBy: 'createTime desc'
      },
      // 产品色号是否启用
      colorNoEnable: false,
      // 初始化完成
      inited: false,
      //用于打断计划数量、计划开始时间、计划完成时间计算循环
      changeSourse: '',
      columns: [
        {
          label: 'jihuadanhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'kehubianma',
          prop: 'wmsCustomerCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'kehumingcheng',
          prop: 'wmsCustomerName',
          sort: 'string',
          width: 130
        },
        {
          label: 'guige',
          prop: 'material.spec',
          sort: 'string',
          width: 130
        },
        {
          label: 'yanse',
          prop: 'material.color',
          width: 130,
          show: false
        },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 130,
          show: false
        },
        {
          label: 'zhichenggongyi',
          prop: 'manufacturingProcess',
          type: 'dictionary',
          key: 'MANUFACTURING_PROCESS',
          width: 130
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient',
          sort: 'string',
          width: 130
        },

        {
          label: 'jihuashuliang',
          prop: 'quantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'yipaichanshuliang',
          prop: 'schedulingQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },
        {
          label: 'shengyushengchanshuliang',
          prop: 'leftProductionQuantity',
          width: 130
        },
        {
          label: 'chaochanshuliang',
          prop: 'overProductionQuantity',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'zhuangtai',
          type: 'slot',
          prop: 'status'
        },
        {
          label: 'shifouwangong',
          type: 'slot',
          prop: 'completed'
        },
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 150
        },
        {
          label: 'huohao',
          prop: 'articleNumber',
          width: 150
        },
        {
          label: 'shengchandingdanfenluid',
          prop: 'orderEntryId',
          width: 150
        },
        {
          label: 'erpxuqiulaiyuandanhao',
          prop: 'erpRequireSourceNo',
          width: 140
        },
        {
          label: 'kucunliang',
          prop: 'inventory',
          width: 130
        },
        {
          label: 'gongyiluxianmingcheng',
          prop: 'craftRoute.name',
          width: 130
        },
        {
          label: 'zhixingyaoqiu',
          prop: 'executionRequirements',
          width: 130
        },
        {
          label: 'erpzhaungtai',
          prop: 'erpStatus',
          width: 130
        },
        {
          label: 'erpwuliaobianma',
          prop: 'material.erpMaterialCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'zhujima',
          prop: 'remarkCode',
          width: 130
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'renli',
          prop: 'manpower',
          width: 130
        },
        {
          label: 'qitabeizhu(zuzhuangchangliaohao)',
          prop: 'attribute3',
          width: 130
        },
        {
          label: 'erpgongdanhanghao',
          prop: 'erpWoLineNo',
          width: 130
        },
        {
          label: 'erpkehubianma',
          prop: 'customerCode',
          width: 130
        },
        {
          label: 'erpkehumingcheng',
          prop: 'customerName',
          width: 130
        },
        {
          label: 'kehudingdanhao',
          prop: 'customerOrderNo',
          width: 130
        },
        {
          label: 'kehuwuliaobianma',
          prop: 'customerMaterialCode',
          width: 130
        },
        {
          label: 'kehuwuliaomingcheng',
          prop: 'customerMaterialName',
          width: 130
        },
        {
          label: 'chuhuoriqi',
          prop: 'deliveryDate',
          type: 'time',
          sort: 'string',
          width: 180
        },
        {
          label: 'maozhong(g)',
          prop: 'material.grossWeight',
          width: 130
        },
        {
          label: 'jingzhong(g)',
          prop: 'material.netWeight',
          width: 130
        },
        {
          label: 'shuikouzhong(g)',
          prop: 'material.sprueWeight',
          width: 130
        },
        {
          label: 'yujilingliaoliang',
          prop: 'prePicking',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ],
      columnsPage: [
        {
          label: 'jihuadanhao',
          prop: 'no',
          sort: 'string',
          width: 130
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'guige',
          prop: 'material.spec',
          sort: 'string',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'quantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'yipaichanshuliang',
          prop: 'schedulingQuantity',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'zhuangtai',
          type: 'slot',
          prop: 'status'
        },
        {
          label: 'jihuakaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'endTime',
          type: 'time',
          width: 150
        },
        {
          label: 'huohao',
          prop: 'articleNumber',
          width: 150
        },
        {
          label: 'shengchandingdanfenluid',
          prop: 'orderEntryId',
          width: 150
        },
        {
          label: 'erpxuqiulaiyuandanhao',
          prop: 'erpRequireSourceNo',
          width: 140
        },
        {
          label: 'kucunliang',
          prop: 'inventory',
          width: 130
        },
        {
          label: 'zhixingyaoqiu',
          prop: 'executionRequirements',
          width: 130
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ],
      ids: ''
    };
  },
  computed: {
    maxValue() {
      return this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
    },
    maxValue2() {
      const quantity = this.yt.editObj.children.map(qt => {
        return qt.quantity;
      });
      const schedulingQuantity = this.yt.editObj.children.map(items => {
        return items.schedulingQuantity;
      });
      return quantity + '' - (schedulingQuantity + '');
    }
  },
  created() {
    this.getProductionConfig();
    const deliveryDateOrderByCookie = this.getCookie('deliveryDateOrderBy');
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      if (deliveryDateOrderByCookie !== null && deliveryDateOrderByCookie !== '') {
        this.$set(this.yt.conditions, 'deliveryDateOrderBy', Number(deliveryDateOrderByCookie));
      }
      this.yt.get(1);
      this.yt.isShowPagination = true;
      this.utils.event_hub.$on('ORDER_MANAGEMENT_REFRESH', () => {
        this.yt.get();
      });
      this.getCustomerList();
    }, 300);
    this.checkIsShowEmployeeNo();
    this.checkIsShowMaterialPassRate();
  },
  watch: {
    /**
     * 监听grossWeight 和 quantity,
     * 大于零才变化
     * 如果quantity和grossWeight为零或为空或为undefined，prePicking设置为0
     */
    grossWeight: {
      handler(n) {
        console.log('grossWeight', n);
        if (n > 0 && this.yt.editObj.quantity > 0) {
          this.yt.editObj.prePicking = (this.yt.editObj.quantity * n) / 1000;
        } else {
          this.yt.editObj.prePicking = 0;
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.quantity': {
      handler(n) {
        console.log('yt.editObj.quantity', n);
        if (n > 0 && this.grossWeight > 0) {
          this.yt.editObj.prePicking = (this.yt.editObj.quantity * this.grossWeight) / 1000;
        } else {
          this.yt.editObj.prePicking = 0;
        }
      },
      immediate: false,
      deep: true
    },

    'yt.editObj.mouldId': {
      handler(n) {
        this.isShowAdaptEqSelect = false;
        this.$nextTick(() => {
          this.isShowAdaptEqSelect = true;
        });
        if (n) {
          this.disabled1 = false;
        }
        if (n != null) {
          let params = {
            pageNum: 1,
            pageSize: 9999,
            mouldId: n,
            materialId: this.yt.editObj.materialId ? this.yt.editObj.materialId : -1
          };
          console.log(params);
          this.http
            .get('/web/basic/mouldEquipment/page', { params })
            .then(res => {
              console.log(res);
              if (res.data.total > 0) {
                let mouldEquipmentId = res.data.rows[0].id;
                this.yt.editObj.children.forEach(child => {
                  params = {
                    pageNum: 1,
                    pageSize: 9999,
                    mouldEquipmentId: mouldEquipmentId,
                    materialId: child.materialId
                  };
                  this.http.get('/web/basic/mouldProduct/page', { params }).then(res => {
                    if (res.data.total > 0) {
                      child.actualCavity = res.data.rows[0].actualCavity;
                    }
                  });
                });
              }
            })
            .catch(e => {});
        }
      },
      immediate: false,
      deep: true
    },
    'yt.conditions.deliveryDateOrderBy': {
      handler(n) {
        if (n === undefined || n === null || n === '') {
          this.setCookie('deliveryDateOrderBy', '', -1);
        } else {
          this.setCookie('deliveryDateOrderBy', n, 365);
        }
      },
      immediate: false
    },
    'yt.editObj.action': {
      handler(n) {
        if (n === 'xinzeng') {
          this.yt.editObj.children = [];
        }
        if (n === 'zengjiafudan') {
          this.yt.editObj.children = [];
        }
        if (n === 'paichan') {
          if (this.yt.editObj) {
            this.scheduling = this.yt.editObj.quantity - this.yt.editObj.schedulingQuantity;
          }
        }
        if (n === 'hedanjilu') {
          if (this.yt.isShowEditDialog == true) {
            this.yt.get();
          }
        }
      },
      immediate: false,
      deep: true
    },
    'yt.isShowEditDialog': {
      handler(n) {
        if (this.yt.editObj.action == 'hedanjilu' && n == false) {
          this.yt.get();
        }
      },
      immediate: false,
      deep: true
    },
    'yt.editObj.curQuantity': {
      handler(n) {
        if (n > this.scheduling) {
          n = this.scheduling;
          this.$set(this.yt.editObj, 'curQuantity', n.toFixed(0));
        }
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    getItem(e) {
      this.grossWeight = e.grossWeight;
      console.log('getItem', e);
    },
    setCookie(name, value, days = 365) {
      let expires = '';
      if (days && days > 0) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      } else if (days < 0) {
        const date = new Date(0);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
    },
    getCookie(name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
      return null;
    },
    // 批量关闭
    batchClosePlan() {
      const selectedRows = this.$refs.batchCloseRef.selectedRows || [];
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('zhishaoxuanzeyitiaoshuju'));
        return;
      }
      Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { s1: '订单管理-生产计划-批量关闭' } });
      this.yt.editObj.loading = true;
      const ids = selectedRows.map(row => row.id);
      this.http
        .post('/web/production/plan/batchClose', ids)
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    syncPlanLth() {
      this.yt.editObj.loading = true;
      this.http
        .get('/custom/lth/plan/sendSyncPlan')
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.yt.editObj.loading = false;
        })
        .catch(error => {
          this.$message.error(this.$t(error));
          this.yt.editObj.loading = false;
        });
    },
    getCustomerList() {
      this.http.get('web/wms/customer/list').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.customerList = res.data;
        }
      });
    },
    // 查询生产配置-启用产品色号管理
    getProductionConfig() {
      this.http.get('/web/production/config/list?type=26&status=1').then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.colorNoEnable = true;
        }
        if (this.colorNoEnable) {
          this.showColumn('sehao');
        } else {
          this.showColumn('yanse');
        }
        this.inited = true;
      });
    },
    // 显示指定列
    showColumn(label) {
      for (let i = 0; i < this.columns.length; i++) {
        const c = this.columns[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    startLoading() {
      this.mainSubImportLoading = true;
    },
    stopLoading() {
      this.mainSubImportLoading = false;
    },
    afterGet() {
      if (this.materialPassRateShow) {
        for (let i = 0; i < this.yt.list.length; i++) {
          if (this.yt.list[i].material.passRate) {
            this.yt.list[i].material.passRate = this.yt.list[i].material.passRate.toFixed(1);
          } else {
            this.$set(this.yt.list[i].material, 'passRate', '100.0');
          }
          if (this.yt.list[i].children && this.yt.list[i].children.length > 0) {
            for (let j = 0; j < this.yt.list[i].children.length; j++) {
              if (this.yt.list[i].children[j].material.passRate) {
                this.yt.list[i].children[j].material.passRate = this.yt.list[i].children[j].material.passRate.toFixed(1);
              } else {
                this.$set(this.yt.list[i].children[j].material, 'passRate', '100.0');
              }
            }
          }
        }
      }
    },
    mainSubImportData() {
      let data = [...this.$refs.weiErPlanOrderBatchReorder.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      //过滤出校验成功的数据
      let filterData = data.filter(item => {
        return item.result === undefined || item.result === '' || item.result === null;
      });
      console.log(filterData);
      if (filterData.length > 0) {
        this.$refs.weiErPlanOrderBatchReorder.exportExcel('导入报告', 'importExcelTable');
        this.mainSubImportLoading = true;
        return this.http
          .post('/custom/weier/plan/batchReorder?onlyValidate=false', filterData)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.mainSubImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.$refs.weiErPlanOrderBatchReorder.exportExcel('导入报告', 'importExcelTable');
      }
    },

    beforeReq(params) {
      params.id = this.yt.editObj.id;
      return params.id;
    },
    // 排产操作
    toScheduling(row) {
      this.recommendEquipment = null;
      this.disabled1 = true;
      // 根据产品ID查询工艺路线, 找不到取通用工艺路线
      const materialId = row.material.id;

      // 获取最新排产的工艺路线
      this.http
        .get('/web/craft/basic/process/route/getRecentScheduled?planId=' + row.id)
        .then(res => {
          if (res.data) {
            this.$set(this.yt.editObj, 'craftId', res.data.id);
          } else {
            this.http
              .get('/web/craft/basic/process/route/product/getRouteIdByMaterialId?materialId=' + materialId)
              .then(res => {
                if (res.data) {
                  this.$set(this.yt.editObj, 'craftId', res.data);
                }
              })
              .catch(err => {
                this.$message.error(this.$t(err));
              });
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });

      this.yt.showEditDialog('paichan', row, 'w1');
      this.setDefaultValue();
    },
    beforeAdd(editObj) {
      let selectedRows = this.$refs.existingPlans.selectedRows;
      console.log('selectedRows:', selectedRows);
      let childrenPlanIds = [];
      for (let i = 0; i < selectedRows.length; i++) {
        childrenPlanIds.push(selectedRows[i].id);
      }
      editObj.childrenPlanIds = childrenPlanIds;
      console.log('beforeAdd:', editObj);
      return editObj;
    },
    // 拼接多工序车间id字符串
    assembleOrg(editObj) {
      if (Array.isArray(editObj.multiProcessOrg) && editObj.multiProcessOrg.length > 0) {
        editObj.multiProcessOrg = editObj.multiProcessOrg.join(',');
      } else {
        editObj.multiProcessOrg = '';
      }
      return editObj;
    },
    // 解析多工序车间字符串
    splitOrg(row) {
      if (row.multiProcessOrg && typeof row.multiProcessOrg === 'string' && row.multiProcessOrg.trim() !== '') {
        // 对row.remark进行分割并转换为数字数组，然后更新到row.multiProcessOrg
        row.multiProcessOrg = row.multiProcessOrg.split(',').map(Number);
      }
    },
    setParentId(row) {
      if (row) {
        this.childrenParentId = row.id;
      }
    },
    //排产保存
    getScheduling(row) {
      this.objectList = row;
      this.recommendEquipment = null;
      this.disabled1 = true;
      // 校验工艺路线
      if (!row.craftId) {
        return this.$message.warning(this.$t('gongyiluxianbukeweikong'));
      }
      this.yt.editObj.loading = true;
      // isCheckMouldStatus
      return this.http
        .post('/web/production/plan/scheduling?isCheckMouldStatus=true', {
          ...row
        })
        .then(response => {
          console.log('response', response);
          if (response.data.code == 0) {
            this.mouldStatus = this.$t(this.store.state.dictJsonAll['BASIC_MOULD_STATUS'][response.data.mouldStatus]);
            this.$confirm('模具处于' + this.mouldStatus + '请确认是否选择排产?', '排产确认', {
              confirmButtonText: '仍继续排产',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.getCheckMouldStatu();
              })
              .catch(() => {
                this.yt.editObj.loading = false;
              });
          } else {
            this.yt.get();
            this.$message.success(this.$t('chenggong'));
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    unbind(row) {
      this.$confirm(this.$t('是否确认解除绑定?'), this.$t('WARNING'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            done();
          }
        }
      })
        .then(() => {
          return this.http
            .post('/web/production/plan/unbind', {
              id: row.id
            })
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.yt.get();
            })
            .catch(error => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    getCheckMouldStatu() {
      return this.http
        .post('/web/production/plan/scheduling?isCheckMouldStatus=false', {
          ...this.objectList
        })
        .then(res => {
          this.yt.get();
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.editObj.loading = false;
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    getCheckScheduling() {
      return this.http
        .post('/web/production/plan/schedulingAndGiveOut?isCheckMouldStatus=false', {
          ...this.schedulingList
        })
        .then(res => {
          this.yt.get();
          this.$message.success(this.$t(res.msg));
          this.yt.isShowEditDialog = false;
          this.yt.editObj.loading = false;
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    //保存并排产
    //web/production/plan/schedulingAndGiveOut
    getSchedulingAndGiveOut(row) {
      this.schedulingList = row;
      this.recommendEquipment = null;
      this.disabled1 = true;
      // 校验工艺路线
      if (!row.craftId) {
        return this.$message.warning(this.$t('gongyiluxianbukeweikong'));
      }
      this.yt.editObj.loading = true;
      return this.http
        .post('/web/production/plan/schedulingAndGiveOut?isCheckMouldStatus=true', {
          ...row
        })
        .then(response => {
          if (response.data.code == 0) {
            this.mouldStatus = this.$t(this.store.state.dictJsonAll['BASIC_MOULD_STATUS'][response.data.mouldStatus]);
            this.$confirm('模具处于' + this.mouldStatus + '请确认是否选择排产发放?', '排产发放确认', {
              confirmButtonText: '仍继续排产',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.getCheckScheduling();
              })
              .catch(() => {
                this.yt.editObj.loading = false;
              });
          } else {
            this.yt.get();
            this.$message.success(this.$t('chenggong'));
            this.yt.isShowEditDialog = false;
            this.yt.editObj.loading = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    //群隆工单信息查询
    getQunlongWorkOrders(row) {
      this.recommendEquipment = null;
      this.yt.editObj.loading = true;
      let obj = {
        lingNo: row.no
      };
      return this.http
        .post('/custom/qunlong/work/orders/queryQunlongWorkOrders', {
          ...obj
        })
        .then(response => {
          let qunlongWork = {
            singleWeight: response.data.singleWeight,
            weight: ((response.data.singleWeight * row.curQuantity) / 1000).toFixed(2)
          };
          Object.assign(qunlongWork, row);
          this.yt.editObj.loading = false;
          this.getSchedulingAndGiveOut(qunlongWork);
        })
        .catch(error => {
          this.$message.error(error);
          this.yt.editObj.loading = false;
        });
    },
    //导出
    exportExcel() {
      let params = this.yt.conditions;
      params.materialId = this.yt.conditions.materialIdList;
      params.startTimeStart = this.yt.conditions.startTime;
      params.startTimeEnd = this.yt.conditions.endTime;
      delete params.startTime;
      delete params.endTime;
      delete params.materialIdList;
      delete params.orderBy;
      this.plan_export_loading = true;
      return this.http
        .get('/web/report/export/production_plan_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.plan_export_loading = false;
        });
    },
    /**
     * 计划数量
     * @param value
     */
    changePlanNumber(value) {
      if (this.yt.editObj.startTime == null || this.yt.editObj.endTime == null) {
      } else if (this.changeSourse != null) {
        return;
      }
      this.$set(this, 'changeSourse', 'planNumber');
      // 计划完成时间=计划开始时间(时间戳)+本次计划数量*标准周期*1000/模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        if (this.materialPassRateShow) {
          //如果合格率(%)不为空，计划完成时间=(计划数量/合格率(%))得出的数量取整， 根据 机模配 所需的生产时间 加上 计划开始时间
          let planQuantity = Math.floor(this.yt.editObj.curQuantity / (this.yt.editObj.material.passRate / 100));
          let endTime = this.yt.editObj.startTime + (planQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        } else {
          const endTime = this.yt.editObj.startTime + (this.yt.editObj.curQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        }
        setTimeout(() => {
          this.changeSourse = null;
        }, 300);
      }
    },
    /**
     * 计划开始时间
     * @param value
     */
    changeStartTime(value) {
      if (this.yt.editObj.curQuantity == null || this.yt.editObj.endTime == null) {
      } else if (this.changeSourse != null) {
        return;
      }
      this.$set(this, 'changeSourse', 'startTime');
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuakaishishijianbunengdayujiahuawanchengshijian'));
        this.yt.editObj.startTime = '';
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.curQuantity) {
        // 计划完成时间=计划开始时间(时间戳)+本次计划数量*标准周期*1000/模穴数
        // 如果合格率(%)不为空，计划完成时间=(计划数量/合格率(%))得出的数量取整， 根据 机模配 所需的生产时间 加上 计划开始时间
        if (this.materialPassRateShow) {
          let planQuantity = Math.ceil(this.yt.editObj.curQuantity / (this.yt.editObj.material.passRate / 100));
          let endTime = this.yt.editObj.startTime + (planQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        } else {
          const endTime = this.yt.editObj.startTime + (this.yt.editObj.curQuantity * this.cycle * 1000) / this.cavity;
          this.$set(this.yt.editObj, 'endTime', endTime);
        }
      }
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        if (!this.materialPassRateShow || this.yt.editObj.material.passRate == 100) {
          const curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity;
          this.$set(this.yt.editObj, 'curQuantity', curQuantity);
        } else {
          let curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity * (this.yt.editObj.material.passRate / 100);
          this.$set(this.yt.editObj, 'curQuantity', curQuantity);
        }
      }
      setTimeout(() => {
        this.changeSourse = null;
      }, 300);
    },
    /**
     * 计划结束时间
     * @param value
     */
    changeEndTime(value) {
      if (this.yt.editObj.curQuantity == null || this.yt.editObj.endTime == null) {
      } else if (this.changeSourse != null) {
        return;
      }
      this.$set(this, 'changeSourse', 'endTime');
      if (this.yt.editObj.startTime && this.yt.editObj.endTime && this.yt.editObj.startTime >= this.yt.editObj.endTime) {
        this.$message.error(this.$t('jihuawanchengshijianbunengxiaoyujihuakaishishijian'));
        this.yt.editObj.endTime = '';
      }
      // 本次计划数量=(计划完成时间(时间戳)-计划开始时间(时间戳))/1000/标准周期*模穴数
      if (this.yt.editObj.startTime !== undefined && this.yt.editObj.startTime !== '' && this.yt.editObj.startTime !== null && this.yt.editObj.endTime !== undefined && this.yt.editObj.endTime !== '' && this.yt.editObj.endTime !== null) {
        if (!this.materialPassRateShow || this.yt.editObj.material.passRate == 100) {
          const curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity;
          this.$set(this.yt.editObj, 'curQuantity', curQuantity);
        } else {
          //如果合格率(%)不为空，计划完成时间=(计划数量/合格率(%))得出的数量取整， 根据 机模配 所需的生产时间 加上 计划开始时间
          let curQuantity = ((this.yt.editObj.endTime - this.yt.editObj.startTime) / 1000 / this.cycle) * this.cavity * (this.yt.editObj.material.passRate / 100);
          this.$set(this.yt.editObj, 'curQuantity', curQuantity);
        }
      }
      setTimeout(() => {
        this.changeSourse = null;
      }, 300);
    },
    /**
     * 选中模糊
     * @param items
     */
    getItems(items) {
      this.cavity = items.cavity;
      this.cycle = items.cycle;
      this.actualCavity = items.actualCavity;
      if (this.actualCavity) {
        this.$set(this.yt.editObj, 'actualCavity', this.actualCavity);
        if (this.yt.editObj.children) {
          for (let i = 0; i < this.yt.editObj.children.length; i++) {
            this.$set(this.yt.editObj.children[i], 'actualCavity', this.actualCavity);
          }
        }
      }
      this.getRecommendEquipment();
    },
    checkIsShowEmployeeNo() {
      for (let index = 0; index < this.store.state.customerTableFields.length; index++) {
        if (this.store.state.customerTableFields[index].tableId == 'web_order_management_production_plan_list_scheduling') {
          this.employeeNoShow = true;
          this.http('/web/setting/shift/getShiftByCustomer').then(res => {
            if (res.data.length > 0) {
              this.firstEmployeeLabel = res.data[0]['name'].concat(this.$t('yuangonggonghao'));
            }
            if (res.data.length > 1) {
              this.secondEmployeeLabel = res.data[1]['name'].concat(this.$t('yuangonggonghao'));
            }
          });
        }
      }
    },
    checkIsShowMaterialPassRate() {
      for (let index = 0; index < this.store.state.customerTableFields.length; index++) {
        if (this.store.state.customerTableFields[index].tableId == 'web_order_management_production_plan_list_scheduling_stlt') {
          this.materialPassRateShow = true;
        }
      }
    },
    setDefaultValue1() {
      if (this.store.state.organizations.length > 0 && this.store.state.organizations[0].children.length > 0 && this.store.state.organizations[0].children[0].children.length > 0) {
        this.yt.editObj.orgId = this.store.state.organizations[0].children[0].children[0]['id'];
      }
    },
    onInput() {
      this.$forceUpdate();
    },
    beforeEdit(editObj) {
      if (editObj.children === undefined) {
        this.$set(editObj, 'children', []);
      }
      console.log('schedulingQuantityDisabled', editObj.schedulingQuantity);
      if (editObj.schedulingQuantity === 0) {
        this.schedulingQuantityDisabled = false;
      } else {
        this.schedulingQuantityDisabled = true;
      }
      return editObj;
    },
    setDefaultValue() {
      this.yt.editObj.priority = 1;
      this.yt.editObj.startTime = [];
      this.yt.editObj.endTime = [];
    },
    submitCombine() {
      // 如果启用产品色号管理, 校验：不同的色号不能合单
      if (this.colorNoEnable) {
        let selectedRows = this.$refs['combineOrders'].selectedRows;
        const seen = new Set();
        for (let i = 0; i < selectedRows.length; i++) {
          const colorNo = selectedRows[i].colorNo;
          if (!seen.has(colorNo)) {
            seen.add(colorNo);
          }
        }
        if (seen.size > 1) {
          this.$message.error(this.$t('sehaobutong,bunenghedan'));
          return;
        }
      }

      let planIdList = this.$refs['combineOrders'].planIdList;
      if (planIdList !== null) {
        this.yt.editObj.loading = true;
        return this.http
          .post('/web/production/plan/merge', planIdList)
          .then(response => {
            this.yt.get();
            this.yt.isShowEditDialog = false;
          })
          .catch(error => {
            this.$message.error(error);
          })
          .finally(() => {
            this.yt.editObj.loading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('请选择需要的单'));
      }
    },

    beforeShowEditDialog(editObj) {
      console.log('asdklasdnabb:', editObj.action);
      if (editObj.action === 'xinzeng' || editObj.action === 'zengjiafudan') {
        editObj.children = [
          {
            no: '',
            materialId: '',
            quantity: undefined,
            erpNo: '',
            remark: ''
          }
        ];
        if (editObj.action === 'zengjiafudan') {
          this.setParentId(editObj);
        }
      }
      return editObj;
    },
    setChildrenItem() {
      this.yt.editObj.children.push({
        no: '',
        materialId: '',
        quantity: undefined,
        erpNo: '',
        remark: ''
      });
    },
    addItem() {
      this.showTitle = true;
      this.showTitle1 = true;
      console.log('this.yt.editObj.children', this.yt.editObj.children);
      this.yt.editObj.children.push({
        no: '',
        materialId: '',
        quantity: undefined,
        erpNo: '',
        remark: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.children = this.yt.editObj.children.filter((item, index) => {
        return index !== key;
      });
    },
    batchUpdateActualCavity() {
      this.$confirm(this.$t('是否批量更新"发放"、"暂停"状态生产工单的实际模腔数?'), this.$t('WARNING'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
              done();
            }, 2000);
          } else {
            done();
          }
        }
      })
        .then(() => {
          return this.http
            .post('/web/production/wo/batchUpdateActualCavity')
            .then(res => {
              this.$message.success(this.$t(res.msg));
              this.yt.get();
            })
            .catch(error => {
              this.$message.error(this.$t(error));
            });
        })
        .catch(() => {});
    },
    printLabel(plan) {
      this.printObj = this.utils.copy(plan);
      this.isShowPrintDialog = true;
      this.isPrint = false;
    },
    closePrintDialog() {
      this.isShowPrintDialog = false;
      this.isShowQrCode = false;
    },
    dayin() {
      this.isPrint = true;
      setTimeout(() => {
        let domSrc = document.getElementById('printContent');
        html2canvas(domSrc).then(async canvas => {
          const imgData = canvas.toDataURL('image/png');
          print({
            printable: imgData,
            type: 'image',
            documentTitle: '',
            modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          });
          this.closePrintDialog();
        });
      }, 50);
    },
    getRecommendEquipment() {
      this.http
        .get('/web/production/wo/getRecommendEquipment', {
          params: {
            mouldId: this.yt.editObj.mouldId,
            materialId: this.yt.editObj.materialId
          }
        })
        .then(res => {
          this.recommendEquipment = res.data;
        });
    },
    choose() {
      this.$set(this.yt.editObj, 'equipmentId', this.recommendEquipment.id);
    },
    closematerialRequirement() {
      this.materialRequirementShow = false;
      this.yt.get();
    },
    // 获取物料即时库存信息(沃德)
    getMaterialInventoryWode() {
      const materialCodeList = this.yt.list.map(item => item.material.code);
      if (materialCodeList.length === 0) return;
      this.yt.editObj.loading = true;
      this.http
        .post('/custom/production/wode/pending/inventory/getMaterialInventory', { materialCodeList })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          if (res.code === 200 && res.data) {
            this.yt.list.forEach(item => {
              const materialCode = item.material.code;
              const inventoryData = res.data[materialCode];
              // 只需更新生产计划中状态为："待排产"、"已排产"记录中的"即时库存"、"欠货数量"、"未交货订单数量"信息即可，"关闭"状态以及"完工"的生产计划单据不做更新
              if (inventoryData && (item.status === 1 || item.status === 2) && !item.completed) {
                // 将库存信息赋值给对应的生产计划项
                this.$set(item, 'instantInventoryQuantity', Math.floor(inventoryData.instantInventoryQuantity));
                this.$set(item, 'undeliveredOrderQuantity', Math.floor(inventoryData.undeliveredOrderQuantity));
                this.$set(item, 'shortageQuantity', Math.floor(inventoryData.shortageQuantity));
              }
            });
          } else {
            this.$message.error(this.$t('kucunxinxiquryibai'));
          }
        })
        .catch(error => {
          this.$message.error(this.$t('kucunxinxiquryichang') + error);
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    }
  },
  destroyed() {
    this.utils.event_hub.$off('ORDER_MANAGEMENT_REFRESH');
  }
};
</script>
